//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $manager from "@/Manager/12.Mes/ProductDataInAddOrderManager";
import PageBtns from "@/components/common_pageBtns.vue";
import { Row, Col, Icon } from "vant";
import { Cell, CellGroup } from "vant";
import { Button } from "vant";

export default {
  components: {
    "footer-button-list": PageBtns,
    [Row.name]: Row,
    [Col.name]: Col,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {      
      orderOpenId:"",
      orderItem:{},

    };
  },
  created() {

    this.loadOrderData();

  },

  computed: {},

  methods: {
    onDetailClick(){
      var url = "/Mes/ProductDataInAddOrder/Detail"
      url += "?openId=" + this.orderOpenId;
      this.$router.push(url);
    },
    onBackClick(){
      var url = "/Mes/ProductDataInAddOrder/Create";
      this.$router.push(url);
    },

    async loadOrderData() {
      var openId = this.$route.query.openId;
      console.log("openId",openId);
      if(!openId){
        this.$msg.error("找不到单据标识[OpenId]");
        return;
      }

      this.$msg.showLoading();
      var result = await $manager.getByOpenId(openId);
      if(result && result.state == 1){
        this.orderOpenId = openId;
        this.orderItem = result.data;
      }
      this.$msg.hideLoading();


      //console.log(result);
    },

  }
};
